import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const ApplicationMain = () => {
  const [customerId, setCustomerId] = useState('');
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get('customerid');
    if (id) {
      setCustomerId(id);
    }
  }, [location]);

  return (
    <div className="pt-20 min-h-screen flex items-center justify-center bg-[#F8F9FA]" data-testid="application-main">
      <div className="max-w-2xl mx-auto px-6 md:px-12 text-center">
        <div className="bg-white border border-[#2C3E50]/5 shadow-sm p-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          <h1 className="font-['Playfair_Display'] text-4xl lg:text-5xl tracking-tight text-[#2C3E50] mb-6" data-testid="thank-you-heading">
            Thank You!
          </h1>
          <p className="text-xl text-[#2E2E2E]/80 leading-relaxed mb-6">
            Your request has been successfully submitted. Our legal team will review your information and contact you shortly.
          </p>
          {customerId && (
            <div className="bg-[#F8F9FA] p-6 mb-6">
              <p className="text-sm text-[#2E2E2E]/70 mb-2">Your Reference ID:</p>
              <p className="font-mono text-lg text-[#2C3E50] font-semibold" data-testid="customer-id">
                {customerId}
              </p>
            </div>
          )}
          <p className="text-base text-[#2E2E2E]/70 mb-8">
            Please keep this reference ID for your records. One of our attorneys will reach out to you within 24-48 hours to discuss your legal needs.
          </p>
          <a
            href="/"
            className="inline-block bg-[#2C3E50] text-white hover:bg-[#1A252F] transition-colors px-8 py-4 font-medium"
            data-testid="back-home-button"
          >
            Back to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default ApplicationMain;
